import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import { registerSetupCode, resolveBoard, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import {
    irRecvDefineCodes,
    markIrEsp8266Used,
    markIrRemoteUsed,
} from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/helper/ir_helper';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

const WAITING_MESSAGE =
    `  Serial.println("================================");\n` +
    `  Serial.println("  赤外線学習モード - 信号の受信を待機中...");\n` +
    `  Serial.println("================================");\n`;

export function register(gen: any): void {
    gen.forBlock['ir_learner'] = function (block: Blockly.Block): string {
        const position = block.getFieldValue('POSITION') as Position;
        const board = resolveBoard(block);
        const pin = BOARD_CONFIG[board].pins[position].second;

        if (board === 'blue') {
            markIrEsp8266Used();
            irRecvDefineCodes.set(String(pin), `IRrecv irrecv_${pin}(${pin});\ndecode_results irResults_${pin};\n`);
            registerSetupCode(`irrecv_${pin}`, `  irrecv_${pin}.enableIRIn();\n` + WAITING_MESSAGE);

            return (
                `if (irrecv_${pin}.decode(&irResults_${pin})) {\n` +
                `  if (irResults_${pin}.overflow) {\n` +
                `    Serial.println("##IR_LEARN_OVERFLOW##");\n` +
                `    irrecv_${pin}.resume();\n` +
                `  } else {\n` +
                `    int rawLen = irResults_${pin}.rawlen;\n` +
                `    if (rawLen >= 20) {\n` +
                `      Serial.println("##IR_LEARN_START##");\n` +
                `      for (int i = 1; i < rawLen; i++) {\n` +
                `        Serial.print(irResults_${pin}.rawbuf[i] * 2, DEC);\n` +
                `        if (i < rawLen - 1) Serial.print(",");\n` +
                `      }\n` +
                `      Serial.println("");\n` +
                `      Serial.println("##IR_LEARN_END##");\n` +
                `      ` +
                stmt(`delay(500)`) +
                `      irrecv_${pin}.resume();\n` +
                `    } else {\n` +
                `      irrecv_${pin}.resume();\n` +
                `    }\n` +
                `  }\n` +
                `}\n`
            );
        } else {
            markIrRemoteUsed();
            irRecvDefineCodes.set(String(pin), `IRrecv irrecv_${pin}(${pin});\n`);
            registerSetupCode(`irrecv_${pin}`, `  irrecv_${pin}.enableIRIn();\n` + WAITING_MESSAGE);

            return (
                `if (irrecv_${pin}.decode()) {\n` +
                `  if (irrecv_${pin}.decodedIRData.flags & IRDATA_FLAGS_WAS_OVERFLOW) {\n` +
                `    Serial.println("##IR_LEARN_OVERFLOW##");\n` +
                `    irrecv_${pin}.resume();\n` +
                `  } else {\n` +
                `    int rawLen = irrecv_${pin}.decodedIRData.rawDataPtr->rawlen;\n` +
                `    if (rawLen >= 20) {\n` +
                `      Serial.println("##IR_LEARN_START##");\n` +
                `      for (int i = 1; i < rawLen; i++) {\n` +
                `        Serial.print(irrecv_${pin}.decodedIRData.rawDataPtr->rawbuf[i] * USECPERTICK, DEC);\n` +
                `        if (i < rawLen - 1) Serial.print(",");\n` +
                `      }\n` +
                `      Serial.println("");\n` +
                `      Serial.println("##IR_LEARN_END##");\n` +
                `      ` +
                stmt(`delay(500)`) +
                `      irrecv_${pin}.resume();\n` +
                `    } else {\n` +
                `      irrecv_${pin}.resume();\n` +
                `    }\n` +
                `  }\n` +
                `}\n`
            );
        }
    };
}
